export const TRANSLATIONS_ES_SETTINGS_CORE = {
  "settings.db_connection_title": "Conexión a Base de Datos",
  "settings.db_tables_title": "Tablas de la Base de Datos",
  "settings.db_table_name": "Nombre de la tabla",
  "settings.db_send_selected": "Enviar tablas seleccionadas",
  "settings.db_loading": "Procesando conexión...",
  "settings.db_connect_success": "Conexión exitosa a la base de datos.",
  "settings.db_connect_error": "Error al conectar a la base de datos.",
  "settings.db_not_configured": "Nunca se han configurado credenciales para conexión.",
  "settings.db_send_success": "Tablas enviadas correctamente.",
  "settings.db_send_error": "Error al enviar tablas.",
  "settings.db_tables_error": "Error al obtener tablas.",
  "settings.db_table_connect_success": "Tabla conectada correctamente.",
  "settings.db_table_connect_error": "Error al conectar la tabla.",
  "settings.cancel": "Cancelar",
  "settings.error_required": "Este campo es obligatorio.",
  "settings.theme": "Tema",
  "settings.language": "Idioma",
  "settings.light": "Claro",
  "settings.dark": "Oscuro",
  "settings.spanish": "Español",
  "settings.english": "Inglés",
  "settings.portuguese": "Portugués",
  "settings.french": "Francés",
  "settings.japanese": "Japonés",
  "settings.title": "Configuración",
  "settings.customization": "Personalización",
  "settings.company_logo": "Logo de la Compañía",
  "settings.logo_placeholder": "Sube tu logo aquí",
  "settings.save": "Guardar",
  "settings.save_error": "Error al guardar la configuración",
  "settings.db_type": "Tipo de Base de Datos",
  "settings.db_host": "Host",
  "settings.db_port": "Puerto",
  "settings.db_user": "Usuario",
  "settings.db_password": "Contraseña",
  "settings.db_name": "Base de Datos",
  "settings.select_db_type": "Seleccione...",
  "settings.tab_preferences": "Preferencias",
  "settings.tab_bc_email_pooling": "BC Email Pooling",
  "settings.bc_title": "Correo BC vinculado",
  "settings.bc_create_btn": "Adicionar correo BC",
  "settings.bc_update_btn": "Actualizar correo BC",
  "settings.bc_create_success": "Correo BC vinculado exitosamente.",
  "settings.bc_create_error": "Error al vincular el correo BC.",
  "settings.bc_update_success": "Correo BC actualizado exitosamente.",
  "settings.bc_update_error": "Error al actualizar el correo BC.",
  "settings.bc_not_configured": "No existe un BC User Binding configurado para este usuario.",
  "settings.whatsapp_not_configured": "No se ha configurado un numero de WhatsApp.",
  "settings.tab_email_oauth": "Permiso correo (OAuth)",
  "settings.email_oauth_title": "Permiso de conexión a correo (OAuth)",
  "settings.email_oauth_placeholder":
    "Aquí podrás autorizar el acceso a tu proveedor de correo (Gmail, Outlook, etc.) próximamente.",
  "settings.tab_advanced": "Avanzado",
  "settings.advanced_title": "Configuración Avanzada",
  "settings.penalty_questions": "Penalización Preguntas",
  "settings.penalty_none": "Sin penalización",
  "settings.penalty_low": "Penalización baja",
  "settings.penalty_medium": "Penalización media",
  "settings.penalty_high": "Penalización alta",
  "settings.penalty_questions.tfidf_min": "TF-IDF mínimo",
  "settings.penalty_questions.embedding_min": "Mínimo de Embedding",
  "settings.penalty_questions.tfidf_penalty": "Penalización TF-IDF",
  "settings.penalty_questions.save": "Guardar configuración de penalización",
  "settings.penalty_questions.load_error":
    "Error al cargar la configuración de penalización.",
  "settings.penalty_questions.save_success":
    "Configuración de penalización guardada correctamente.",
  "settings.penalty_questions.save_error":
    "Error al guardar la configuración de penalización.",
  "settings.penalty_questions.enabled": "Habilitar penalización de preguntas",
  "settings.penalty_questions.header_parameter": "Parámetro de penalización",
  "settings.penalty_questions.header_value": "Valor de penalización",
  "settings.all_types": "Todos los tipos",
  "settings.select": "Seleccionar",
  "settings.edit": "Editar",
  "settings.delete": "Eliminar",
  "settings.tables": "Tablas",
  "settings.search_table": "Buscar tabla",
  "settings.no_tables": "No hay tablas disponibles",
  "settings.database": "Base de datos",
  "settings.host": "Host",
  "settings.port": "Puerto",
  "settings.username": "Usuario",
  "settings.password": "Contraseña",
  "settings.logo_help": "Sube un logo en formato PNG o SVG",
  "settings.logo_error": "Error al subir el logo",
  "settings.close": "Cerrar",
  "settings.save_success": "Configuración guardada correctamente",
  "settings.bc_email_label": "Email de BC",
  "settings.db_delete_success": "Conexión a BD eliminada correctamente",
  "settings.db_delete_error": "Error al eliminar la conexión a BD",
  "settings.select_tables": "Seleccionar tablas",
  "settings.whatsapp_title": "Configuración de WhatsApp",
  "settings.whatsapp_country_code": "Código de país",
  "settings.whatsapp_country_code_placeholder": "Ingresa código de país",
  "settings.whatsapp_country_code_error": "Ingresa un código de país válido",
  "settings.whatsapp_number": "Número de WhatsApp",
  "settings.whatsapp_number_error": "Número inválido",
  "settings.whatsapp_invalid_number": "Número inválido",
  "settings.whatsapp_invalid_reason_format": "Formato inválido",
  "settings.whatsapp_invalid_reason_possible": "Número no posible para el país seleccionado",
  "settings.whatsapp_invalid_reason_valid": "Número no válido",
  "settings.whatsapp_save_btn": "Guardar",
  "settings.whatsapp_save_success": "Número de WhatsApp guardado correctamente",
  "settings.whatsapp_save_error": "Error al guardar el número de WhatsApp",
  "settings.whatsapp_update_success": "Número de WhatsApp actualizado",
  "settings.whatsapp_update_error": "Error al actualizar el número de WhatsApp",
  "settings.whatsapp_delete_btn": "Eliminar",
  "settings.whatsapp_delete_success": "Número de WhatsApp eliminado",
  "settings.whatsapp_delete_error": "Error al eliminar el número de WhatsApp",
  "settings.whatsapp_edit_btn": "Editar",
  "settings.whatsapp_configured_number": "Número configurado:",
  "settings.tab_google_integrations": "Integraciones de Google",
  "settings.tab_microsoft_integrations": "Integraciones de Microsoft",
  "settings.reindex.title": "Reindexar documentación",
  "settings.reindex.description": "Reprocesa todos tus documentos en Home IA y Knowledge Hub (reclasificación y extracción de conocimiento). Úsalo si cambiaste tus reglas o quieres actualizar el análisis. No vuelve a subir archivos.",
  "settings.reindex.button": "Reindexar mis documentos",
  "settings.reindex.confirm": "Sí, reindexar",
  "settings.reindex.cancel": "Cancelar",
  "settings.reindex.error": "No se pudo iniciar la reindexación. Intenta de nuevo.",
  "settings.purge.title": "Borrar todos mis documentos",
  "settings.purge.description": "Elimina definitivamente todos tus documentos (incluidos los archivos), conversaciones, clasificaciones y datos de Home IA y Knowledge Hub. También desconecta tus cuentas de Google y Microsoft (elimina sus tokens y registros de sincronización), por lo que tendrás que volver a conectarlas para sincronizar de nuevo. El historial de uso de tokens se conserva. La limpieza se ejecuta en segundo plano y recibirás una notificación al finalizar.",
  "settings.purge.button": "Borrar todos mis documentos",
  "settings.purge.confirm": "Sí, borrar todo",
  "settings.purge.cancel": "Cancelar",
  "settings.purge.error": "No se pudo iniciar la limpieza. Intenta de nuevo.",
};
